<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1100"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          <div>
            <div>Camera Calibration</div>
          </div>
        </v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn icon @click="onCloseClick()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col>
            <v-card id="printableArea" flat style="padding:5px;overflow-y: auto; height: 300px; background-color: #F5F5F5;">
              <TwoColumnText leftText="Operator:" :rightText="cameraCal.Operator"></TwoColumnText>
              <TwoColumnText leftText="Version:" :rightText="cameraCal.Version"></TwoColumnText>
              <TwoColumnText leftText="Date:" :rightText="cameraCal._date"></TwoColumnText>
              <TwoColumnText leftText="Accelerometer Calibration Time:" :rightText="cameraCal.AccelCalTime"></TwoColumnText>
              <TwoColumnText leftText="Camera to Accelerometer Calibration Time:" :rightText="cameraCal.CCS_ACSTime"></TwoColumnText>
              <TwoColumnText leftText="Camera Calibration Time:" :rightText="cameraCal.camCalTime"></TwoColumnText>

              <TwoColumnText leftText="Left Boards" rightText="---------------------------------------------------"></TwoColumnText>
              <Board
                v-for="(item, index) in cameraCal.LeftBoards"
                :index="index"
                :board="item"
                :key="item.id"
              >
              </Board>

              <TwoColumnText leftText="Right Boards" rightText="---------------------------------------------------"></TwoColumnText>
              <Board
                v-for="(item, index) in cameraCal.RightBoards"
                :index="index"
                :board="item"
                :key="item.id"
              >
              </Board>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <!--<v-btn color="green" text @click="onPrintClick()">Print</v-btn>-->
        <v-btn color="grey lighten-1" @click="onCloseClick()">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import TwoColumnText from './TwoColumnText.vue';
import Board from './Board.vue';

export default {
  components: {
    TwoColumnText,
    Board,
  },

  props: {
    dialog: Boolean,
    cameraCal: Object,
  },

  methods: {
    onCloseClick() {
      this.$emit('close');
    },
  },
};
</script>
